import { createSlice } from '@reduxjs/toolkit';
import { ITimesContext } from '../../interfaces/StoreTypes';
import { getTimes } from '../thunks/timesThunks';

const initialState: ITimesContext = {
  times: [],
  timeLoading: false,
  sumYear: { workingTime: 0, availableTime: 0 },
  sumMonth: { workingTime: 0, availableTime: 0 },
  sumLastMonth: { workingTime: 0, availableTime: 0 },
  firstTimeDay: null,
  evaluateTimes: [],
  timesLastRefresh: 0,
};

export const timesSlice = createSlice({
  name: 'times',
  initialState,
  reducers: {
    setTimes: (state, action) => {
      state.times = action.payload;
    },
    setTimesLoading: (state, action) => {
      state.timeLoading = action.payload;
    },
    setSumYear: (state, action) => {
      state.sumYear = action.payload;
    },
    setSumMonth: (state, action) => {
      state.sumMonth = action.payload;
    },
    setSumLastMonth: (state, action) => {
      state.sumLastMonth = action.payload;
    },
    setFirstTimeDay: (state, action) => {
      state.firstTimeDay = action.payload;
    },
    setEvaluateTimes: (state, action) => {
      state.evaluateTimes = action.payload;
    },
    setTimesLastRefresh: (state, action) => {
      state.timesLastRefresh = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getTimes.fulfilled, () => {});
  },
});

export const {
  setTimes,
  setTimesLoading,
  setSumYear,
  setSumMonth,
  setSumLastMonth,
  setFirstTimeDay,
  setEvaluateTimes,
  setTimesLastRefresh,
} = timesSlice.actions;

export default timesSlice.reducer;
